/**
 * DN: Immer nur ein Drawer auf einmal.
 *
 * Das Theme laesst jeden Dialog nur sich selbst schalten: jeder haengt an
 * [aria-controls="<eigene-id>"] und kennt die anderen nicht. Navi, Warenkorb und
 * Suche sind Geschwister unter <x-header>, also greift auch die Aussenklick-Logik
 * nicht — ein Klick auf das Warenkorb-Symbol gilt der Navi nicht als "aussen".
 * Folge auf dem Handy: bei offener Navi oeffnet sich der zweite Drawer DARUEBER,
 * die Navi bleibt darunter stehen, und wer den oberen schliesst, landet wieder
 * in der Navi. Von aussen sieht das aus, als liesse sich der Warenkorb nicht
 * erreichen.
 *
 * Der Klick wird deshalb in der Capture-Phase abgefangen, also bevor die Drawer
 * ihre eigenen Handler ausfuehren: erst den offenen schliessen, dann den neuen
 * oeffnen lassen. Die Scroll-Sperre selbst ist unkritisch, sie zaehlt Schichten
 * (lockLayerCount in theme.js) und liegt am <html>, nicht am <body>. Die
 * Reihenfolge zaehlt trotzdem, weil der schliessende Drawer nach seiner
 * Leave-Animation unbedingt display:none setzt (theme.js) — laeuft das nach dem
 * Oeffnen des neuen, trifft es unter Umstaenden den falschen.
 *
 * Aus demselben Grund werden Auslöser ignoriert, solange ihr Ziel noch in der
 * Animation steckt: zwei schnelle Taps auf die nebeneinanderliegenden Symbole
 * haben sonst die Sperre stehen lassen, ohne dass ein Drawer sichtbar war.
 */
(() => {
  const IDS = ['menu-drawer', 'cart-drawer', 'search-drawer'];

  const schliesseAndere = (zielId) => {
    for (const id of IDS) {
      if (id === zielId) continue;
      const d = document.getElementById(id);
      if (!d || !d.hasAttribute('open')) continue;
      // hide() statt removeAttribute: die Komponente raeumt Fokusfalle,
      // Scroll-Sperre und Aktivator-Referenz selbst auf.
      if (typeof d.hide === 'function') {
        d.setAttribute('data-dn-wechsel', '');
        Promise.resolve(d.hide()).finally(() => d.removeAttribute('data-dn-wechsel'));
      } else {
        d.removeAttribute('open');
      }
    }
  };

  document.addEventListener('click', (event) => {
    const ausloeser = event.target.closest('[aria-controls]');
    if (!ausloeser) return;
    const zielId = ausloeser.getAttribute('aria-controls');
    if (!IDS.includes(zielId)) return;

    const ziel = document.getElementById(zielId);
    // Ein Klick auf den bereits offenen Drawer schliesst ihn nur; dann gibt es
    // nichts zu koordinieren.
    if (ziel && ziel.hasAttribute('open')) return;

    // Solange irgendein koordinierter Drawer noch animiert, schlucken wir den
    // Klick. Sonst raeumt die auslaufende Leave-Animation den gerade geoeffneten
    // Drawer wieder ab und es bleibt die Sperre ohne sichtbaren Drawer stehen.
    if (IDS.some((id) => document.getElementById(id)?.hasAttribute('data-dn-wechsel'))) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    schliesseAndere(zielId);
  }, true);
})();
